/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodashIntersection = require('lodash/intersection');

var _lodashIntersection2 = _interopRequireDefault(_lodashIntersection);

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashPluck = require('lodash.pluck');

var _lodashPluck2 = _interopRequireDefault(_lodashPluck);

var MetaBar = (function (_Component) {
	_inherits(MetaBar, _Component);

	function MetaBar() {
		_classCallCheck(this, MetaBar);

		_Component.apply(this, arguments);
	}

	MetaBar.prototype.render = function render() {
		var _classNames;

		var styles = require('./MetaBar.css');

		var _props = this.props;
		var articleID = _props.articleID;
		var author = _props.author;
		var authorURI = _props.authorURI;
		var categories = _props.categories;
		var commentCount = _props.commentCount;
		var label = _props.label;
		var noLinks = _props.noLinks;
		var postDate = _props.postDate;
		var specialSeries = _props.specialSeries;
		var withPostTime = _props.withPostTime;

		// Create array from the `slug` property of categories
		var categorySlugs = _lodashPluck2['default'](categories, 'slug');

		// Compare that array to the `dominantCategories` from settings.js to
		// see if there are any intersecting values.
		var dominantCategory = _lodashIntersection2['default'](_srcSettings2['default'].dominantCategories, categorySlugs);

		// Finally, select the category object to use based on the
		// previous findings.
		var section = undefined;
		if (dominantCategory.length) {
			section = _lodashFind2['default'](categories, { 'slug': dominantCategory[0] });
		} else {
			section = _lodashFind2['default'](categories, { 'parent': 24 });
		}

		var categoryClassNames = _classnames2['default']((_classNames = {}, _classNames[styles.Link] = true, _classNames[styles['Link--featured']] = dominantCategory ? dominantCategory.length : false, _classNames));

		return _react2['default'].createElement(
			'div',
			{ className: styles.Base },
			label && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				label
			),
			specialSeries && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles['Link--specialSeries'], to: '/special-series/' + specialSeries.slug, title: 'Special Series: ' + specialSeries.name },
					'Special Series'
				)
			),
			categories && section && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				_react2['default'].createElement(_reactRouter.Link, { className: categoryClassNames, to: '/section/' + section.slug, dangerouslySetInnerHTML: { __html: section.name } })
			),
			author && noLinks || author && !authorURI && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				'by ',
				author
			),
			author && !noLinks && authorURI && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				'by ',
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.ItemLink, to: '/contributors/' + authorURI },
					author
				)
			),
			withPostTime && _react2['default'].createElement(
				'span',
				{ className: styles.Item },
				_moment2['default'](postDate, _srcSettings2['default'].dates.defaultFormat).format('h:mm a')
			),
			_react2['default'].createElement(
				'span',
				{ className: styles.Item },
				_moment2['default'](postDate, _srcSettings2['default'].dates.defaultFormat).format('MMM D, YYYY')
			),
			commentCount !== undefined && _react2['default'].createElement(_components.CommentCount, {
				articleID: articleID,
				className: styles['Item--asLink'],
				count: commentCount,
				link: noLinks ? null : '#comments' })
		);
	};

	_createClass(MetaBar, null, [{
		key: 'propTypes',
		value: {
			articleID: _react.PropTypes.number,
			author: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
			authorURI: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
			categories: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]),
			commentAnchor: _react.PropTypes.string,
			commentCount: _react.PropTypes.number,
			label: _react.PropTypes.string,
			noLinks: _react.PropTypes.bool,
			postDate: _react.PropTypes.string.isRequired,
			specialSeries: _react.PropTypes.object,
			withPostTime: _react.PropTypes.bool
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			articleID: null,
			noLinks: false
		},
		enumerable: true
	}]);

	return MetaBar;
})(_react.Component);

exports['default'] = MetaBar;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MetaBar/MetaBar.js
 ** module id = 683
 ** module chunks = 0
 **/